(function (modules) {
  modules.forEach((moduleName) => {
    const fallback = new Proxy(
      {},
      {
        get() {
          return function () {
            return Promise.resolve();
          };
        },
      },
    );
    if (!window[moduleName]) {
      console.log(
        `%casync package`,
        `background: purple; color: white; padding: 2px`,
        `${moduleName} not available, is now falling back to NULL`,
      );
      window[moduleName] = fallback;
    }
  });
})(['__ZM_BILLING_SHARED']);
